import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebCompany } from "src/app/models";
import { CompanyService } from "src/app/services";
import { TheMaskedEmail } from "./TheMaskedEmail";

export interface EmailListData
{
  emails: string[]

};

@Component({
  selector: "app-email-list-dialog",
  templateUrl: "./email-list-dialog.component.html",
  styleUrls: ["./email-list-dialog.component.scss"]
})
export class EmailListDialogComponent implements OnInit
{

  public emails: TheMaskedEmail[] = [];
  public webEmail: string;
  public company: WebCompany;


  constructor(
    public dialogRef: MatDialogRef<EmailListDialogComponent>,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public data: EmailListData) { }

  ngOnInit(): void
  {
    this.data.emails?.forEach(e =>
    {
      let email = new TheMaskedEmail(e);
      this.emails.push(email);
    });
    this.companyService.company.subscribe(c =>
    {
      this.company = c;

      this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;

    });
  }

  handleCloseClick(): void
  {
    this.dialogRef.close();
  }

}
